import { Button, Flex } from 'antd'
import Image from 'next/image'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import introEnSrc from '@/assets/images/insight-report/intro-en.png'
import introJpSrc from '@/assets/images/insight-report/intro-jp.png'
import introZhSrc from '@/assets/images/insight-report/intro-zh.png'
import VipButton from '@/components/vip-button'
import routes from '@/hooks/use-authorization/routes'
import { useI18n } from '@/hooks/use-i18n'
import { usePermissions } from '@/hooks/use-permissions'
import { SupportedLanguages } from '@/i18n/config'
import { useIntl } from '@/i18n/hooks/use-intl'

const ctaImgSrcMap: Record<SupportedLanguages, string> = {
  [SupportedLanguages.zhTW]: introZhSrc,
  [SupportedLanguages.ja]: introJpSrc,
  [SupportedLanguages.enUS]: introEnSrc,
  [SupportedLanguages.ach]: introEnSrc,
}

const ReportCta: FunctionComponent = () => {
  const { formatMessage } = useIntl()
  const { language } = useI18n()

  const { withFreePermission, withReportPermission } = usePermissions()

  return (
    <Container>
      <Image
        alt='Report CTA'
        height={300}
        src={ctaImgSrcMap[language.i18nCode]}
        width={450}
      />
      <Flex vertical align='center' gap={8}>
        <Title>
          {formatMessage({
            id: 'kol_cooperation_detail_drawer:tabs_report_collaboration_record_title',
          })}
        </Title>
        <Description>
          {formatMessage({
            id: 'kol_cooperation_detail_drawer:tabs_report_collaboration_record_description',
          })}
        </Description>
      </Flex>
      {withReportPermission ? (
        <Button href={routes.insightReport.stringifyUrl({})} type='primary'>
          {formatMessage({ id: 'general:navigate_to_create' })}
        </Button>
      ) : (
        <VipButton
          buttonProps={{ href: routes.workspacePlan.stringifyUrl({}) }}
        >
          {withFreePermission
            ? formatMessage({ id: 'vip:upgrade_plan_btn' })
            : formatMessage({ id: 'payment:plan_purchase_btn' })}
        </VipButton>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 30px;
`

const Title = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`

const Description = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export default ReportCta
